import { IGetCustomemrTaxDetail } from "@/api";
import { PRO_SET } from "./finance.config";

export const NETFILE = [PRO_SET.ONE, PRO_SET.TOW, PRO_SET.THERE, PRO_SET.FOUR];

export type IKeyVal = Record<string, any>;

// 个人所得税  1104
// 增值税及附加 1101
// 财务报表 1103
// 企业所得税 1102
// 社保 1113

// 【个税申报人员确认】 1104
// 【社保明细】 1113
// 【申报税款明细】 1101  amount  1102 amount 1103 amount  1104 amount  sum  totalAmount
// 【报税情况说明】
// 【税种缴款情况说明】

export enum TYPE_NETFILE {
  ZZSJFJS = 1101, // 增值税及附加税 -增值税及附加税费申报
  QYSDS = 1102, // 企业所得税 - 居民企业（查账征收）企业所得税月（季）度申报
  CWBB = 1103, // 财务报表 - 财务报表报送（月季报）
  GRGZXJ = 1104, // 个人工资薪金 - 个人工资薪金
  GRJYSD = 1105, // 个人经营所得 - 个人经营所得
  WGSYJSF = 1106, // 文化事业建设费 - 文化事业建设费申报（广告业）
  GHJF = 1107, // 工会经费 - 通用申报（工会经费）
  SLJSJJ = 1108, // 水利建设基金 - 通用申报（水利建设基金）
  CJRJYBZJ = 1109, // 残疾人就业保障金 - 残疾人就业保障金申报
  CZLJCLF = 1111, // 城镇垃圾处理费 - 非税收入通用申报（城镇垃圾处理费）
  CCHXWS = 1112, // 财产和行为税 - 印花税
  SBFNB = 1113, // 社保费年报 - 社保费申报
  QYSDSNB = 110201, // 企业所得税年报 - 居民企业（查账征收）企业所得税年度申报
  JYSDBNB = 110202, // 经营所得B表年报 - 经营所得（B表）申报
  CWBBNB = 110301, // 财务报表年报 - 财务报表报送（年报）
}

// 0：未完成 1：部分完成 2：已完成 3：无需申报
export enum NETFILE_STATUS {
  UNFINISHED = 0,
  PARTIALLY_FINISHED = 1,
  FINISHED = 2,
  UNNECESSARY = 3,
}
export const netfileStatus = [
  { label: "未完成", value: NETFILE_STATUS.UNFINISHED, color: "#f4ce98" },
  { label: "部分完成", value: NETFILE_STATUS.PARTIALLY_FINISHED, color: "#f4ce98" },
  { label: "已完成", value: NETFILE_STATUS.FINISHED, color: "#81b337" },
  { label: "无需申报", value: NETFILE_STATUS.UNNECESSARY, color: "#81b337" },
];
export const getNetfileStatus = (val: NETFILE_STATUS) => netfileStatus.find((item) => item.value === val);

// 0 未申报 1 申报中 2 已完成 3 异常 5 已申报未缴款
export enum CARD_STATUS {
  UNFINISHED = 0,
  PARTIALLY_FINISHED = 1,
  FINISHED = 2,
  UNNECESSARY = 3,
  APPLIED_UNPAID = 5,
}
export const cardStatus = [
  { label: "未申报", value: CARD_STATUS.UNFINISHED, color: "#f4ce98" },
  { label: "申报中", value: CARD_STATUS.PARTIALLY_FINISHED, color: "#f4ce98" },
  { label: "已完成", value: CARD_STATUS.FINISHED, color: "#81b337" },
  { label: "异常", value: CARD_STATUS.UNNECESSARY, color: "#db8e88" },
  { label: "已申报未缴款", value: CARD_STATUS.APPLIED_UNPAID, color: "#f4ce98" },
];
export const getCardStatus = (val: CARD_STATUS) => cardStatus.find((item) => item.value === val);

export interface INetfileName {
  name: string;
  label: string;
  forms?: {
    label: string;
    value: keyof IGetCustomemrTaxDetail["otherTaxDetail"][0];
    suffix?: string;
  }[];
  isButton?: boolean;
}

export const netfileName: {
  [key in TYPE_NETFILE]: INetfileName;
} = {
  [TYPE_NETFILE.ZZSJFJS]: {
    name: "增值税及附加税",
    label: "增值税及附加税费申报",
    forms: [
      { label: "增值税", value: "vatAmount" },
      { label: "城市维护建设税", value: "cjsAmount" },
      { label: "教育费附加税", value: "jyfjAmount" },
      { label: "地方教育费附加税", value: "dfjyAmount" },
    ],
  },
  [TYPE_NETFILE.QYSDS]: {
    name: "企业所得税",
    label: "居民企业（查账征收）企业所得税月（季）度申报",
  },
  [TYPE_NETFILE.CWBB]: {
    name: "财务报表",
    label: "财务报表报送（月季报）",
  },
  [TYPE_NETFILE.GRGZXJ]: {
    name: "个人所得税",
    label: "个人工资薪金",
    forms: [
      { label: "工资人数", value: "wagesEmployeNum", suffix: "人" },
      { label: "工资总额", value: "wagesAmount", suffix: "元" },
    ],
    isButton: true,
  },
  [TYPE_NETFILE.GRJYSD]: {
    name: "个人经营所得",
    label: "个人经营所得月（季）度申报",
  },
  [TYPE_NETFILE.WGSYJSF]: {
    name: "个人经营所得",
    label: "文化事业个人经营所得建设费申报（广告业）",
  },
  [TYPE_NETFILE.GHJF]: {
    name: "工会经费",
    label: "通用申报（工会经费）",
  },
  [TYPE_NETFILE.SLJSJJ]: {
    name: "水利建设基金",
    label: "通用申报（水利建设基金）",
  },
  [TYPE_NETFILE.CJRJYBZJ]: {
    name: "残疾人就业保障金",
    label: "残疾人就业保障金申报",
  },
  [TYPE_NETFILE.CZLJCLF]: {
    name: "城镇垃圾处理费",
    label: "非税收入通用申报（城镇垃圾处理费）",
  },
  [TYPE_NETFILE.CCHXWS]: {
    name: "财产和行为税",
    label: "印花税",
  },
  [TYPE_NETFILE.SBFNB]: {
    name: "社保费年报",
    label: "社保费申报",
  },
  [TYPE_NETFILE.QYSDSNB]: {
    name: "企业所得税年报",
    label: "居民企业（查账征收）企业所得税年度申报",
  },
  [TYPE_NETFILE.JYSDBNB]: {
    name: "经营所得B表年报",
    label: "经营所得（B表）申报",
  },
  [TYPE_NETFILE.CWBBNB]: {
    name: "财务报表年报",
    label: "财务报表报送（年报）",
  },
};

export const getNetfileItem = (type: TYPE_NETFILE) => netfileName[type];
export const getNetfileName = (type: TYPE_NETFILE) => getNetfileItem(type).name;
export const getNetfileLabel = (type: TYPE_NETFILE) => getNetfileItem(type).label;

export interface IButton {
  label: string;
  id: string;
  status?: CARD_STATUS[];
  template: string;
  type?: TYPE_NETFILE;
  table?: { name: string; value: string }[];
  list?: { label: string; value: string }[];
  images?: keyof IGetCustomemrTaxDetail["otherTaxDetail"][0];
}

// 报税页的 5 个硬编码模板已于 202609 删除：话术改由消息模板统一维护，
// 前端只调 RenderableTemplates / GroupSendTemplateContent 取渲染结果（见 07 文档）。
// 下面的 IButton 与 getTemplateStr 保留，发票页 invoice.config.ts 仍在用。

/** 模板转换为字符串 */
export const getTemplateStr = (item: IButton, data: IKeyVal, tableData: IKeyVal[]): string => {
  // 文字长度不固定，不预设固定空格数量，使用空字符串作为间隔
  const space = " \t\t ";
  const arr: string[] = item.table
    ? [
        item.table.map((item) => getValue(item.name)).join(space), //
        ...tableData.map((obj): string => item.table?.map(({ value }) => getValue(obj[value])).join(space) || ""),
      ]
    : [];

  return item.template.replace(/\{\{(\w+)\}\}/g, (match, key) => {
    console.log("🚀 ~ getTemplateStr ~ match, key:", match, key, data[key]);
    if (key == "table") return arr.join("\n");
    else if (key == "list") return tableData.map((item) => `${getNetfileLabel(item.inventoryId as TYPE_NETFILE)}：${getValue(item.amount)}`).join("\n");
    else return getValue(data[key]);
  });
};

export const getValue = (value: string) => {
  return value || value == "0" ? value : "";
};
